var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [_vm._v("设备信息台账")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }